import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from '../../locales/i18n'; // adjust path as needed
import { setLanguage } from '../../store/slices/languageSlice'; // adjust path as needed
import Header2 from '../../component/NewComponents/Header2';
import { FaLanguage, FaCheck, FaArrowLeft } from 'react-icons/fa6';
import classes from './LanguagePage2.module.css';

const LANGUAGES = [
    {
        value: '0',
        label: 'English',
        native: 'English',
        flag: '🇬🇧',
        region: 'Global',
    },
    {
        value: '1',
        label: 'French',
        native: 'Français',
        flag: '🇫🇷',
        region: 'France',
    },
];

const LanguagePage2 = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { selectedLanguage } = useSelector((state) => state.languageSlice);
    const { t } = useTranslation();

    useEffect(() => {
        if (selectedLanguage && i18n.language !== selectedLanguage) {
            i18n.changeLanguage(String(selectedLanguage));
        }
    }, [selectedLanguage]);

    const handleSelect = (value) => {
        dispatch(setLanguage(value));
    };

    return (
        <div className={classes.page}>
            <Header2 active={4} />

            <main className={classes.main}>

                {/* ── Hero bar ── */}
                <div className={classes.heroBar}>
                    <div className={classes.heroLeft}>
                        <button
                            type="button"
                            className={classes.backBtn}
                            onClick={() => navigate(-1)}
                        >
                            <FaArrowLeft />
                        </button>
                        <div className={classes.heroText}>
                            <span className={classes.heroEyebrow}>{t("182")}</span>
                            <h1 className={classes.heroTitle}>{t("183")} <em>{t("184")}</em></h1>
                        </div>
                    </div>
                    <div className={classes.heroMeta}>
                        <span className={classes.profileChip}>
                            <FaLanguage className={classes.chipIcon} />
                            {t("185")}
                        </span>
                    </div>
                </div>

                {/* ── Body ── */}
                <div className={classes.body}>

                    {/* ── Info card ── */}
                    <div className={classes.infoCard}>
                        <div className={classes.cardBg} />
                        <div className={classes.infoIconWrap}>
                            <FaLanguage className={classes.infoIcon} />
                        </div>
                        <div className={classes.infoText}>
                            <p className={classes.infoTitle}>{t("186")}</p>
                            <p className={classes.infoSub}>
                                {t("187")}
                            </p>
                        </div>
                    </div>

                    {/* ── Language options ── */}
                    <div className={classes.optionsSection}>
                        <span className={classes.groupLabel}>{t("188")}</span>

                        <div className={classes.menuCard}>
                            {LANGUAGES.map((lang, idx) => {
                                const isSelected = String(selectedLanguage) === lang.value;
                                return (
                                    <React.Fragment key={lang.value}>
                                        {idx > 0 && <div className={classes.menuDivider} />}
                                        <button
                                            type="button"
                                            className={`${classes.langItem} ${isSelected ? classes.langItemActive : ''}`}
                                            onClick={() => handleSelect(lang.value)}
                                        >
                                            <div className={classes.flagWrap}>
                                                <span className={classes.flag}>{lang.flag}</span>
                                            </div>

                                            <div className={classes.langText}>
                                                <span className={classes.langLabel}>{lang.label}</span>
                                                <span className={classes.langMeta}>
                                                    {lang.native} &middot; {lang.region}
                                                </span>
                                            </div>

                                            <div className={`${classes.checkWrap} ${isSelected ? classes.checkWrapActive : ''}`}>
                                                {isSelected && <FaCheck className={classes.checkIcon} />}
                                            </div>
                                        </button>
                                    </React.Fragment>
                                );
                            })}
                        </div>

                        <p className={classes.hint}>
                            {t("189")}
                        </p>
                    </div>

                </div>
            </main>
        </div>
    );
};

export default LanguagePage2;